import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESS_ADDRESS_EDIT_MODAL_OPEN = 'BUSINESS_ADDRESS_EDIT_MODAL_OPEN'
export const BUSINESS_ADDRESS_EDIT_MODAL_CLOSE = 'BUSINESS_ADDRESS_EDIT_MODAL_CLOSE'
export const BUSINESS_ADDRESS_EDIT_MODAL_CANCEL = 'BUSINESS_ADDRESS_EDIT_MODAL_CANCEL'
export const BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES = 'BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES'
export const BUSINESS_ADDRESS_EDIT_MODAL_VALIDATE = 'BUSINESS_ADDRESS_EDIT_MODAL_VALIDATE'
export const BUSINESS_ADDRESS_EDIT_MODAL_RESET = 'BUSINESS_ADDRESS_EDIT_MODAL_RESET'

function open(content) {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_OPEN,
    content,
  }
}

function close() {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_CLOSE,
  }
}

function cancel() {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_CANCEL,
  }
}

function saveChanges(newData) {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES,
    newData,
  }
}

function validate(isValidated) {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_VALIDATE,
    isValidated,
  }
}

function reset() {
  return {
    type: BUSINESS_ADDRESS_EDIT_MODAL_RESET,
  }
}

export const openBusinessAddressModalDialog = (content) => (dispatch) => {
  dispatch(open(content))
}

export const closeBusinessAddressModalDialog = () => (dispatch) => {
  dispatch(close())
}

export const cancelBusinessAddressModalDialog = () => (dispatch) => {
  dispatch(cancel())
}

export const saveChangesBusinessAddressModalDialog = (data) => (dispatch) => {
  dispatch(saveChanges(data))
}

export const validateBusinessAddressModalDialog = (isValid) => (dispatch) => {
  dispatch(validate(isValid))
}

export const resetBusinessAddressModalDialog = () => (dispatch) => {
  dispatch(reset())
}

// API call to update business info
export const BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST = 'BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST'
export const BUSINESS_ADDRESS_EDIT_UPDATE_SUCCESS = 'BUSINESS_ADDRESS_EDIT_UPDATE_SUCCESS'
export const BUSINESS_ADDRESS_EDIT_UPDATE_FAILURE = 'BUSINESS_ADDRESS_EDIT_UPDATE_FAILURE'

export const updateBusinessAddress = (id, addressId, body) => ({
  [CALL_API]: {
    endpoint: '/api/business/businesses/' + id + '/addresses/' + addressId + '/',
    types: [
      BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST,
      BUSINESS_ADDRESS_EDIT_UPDATE_SUCCESS,
      BUSINESS_ADDRESS_EDIT_UPDATE_FAILURE,
    ],
    method: 'PATCH',
    body,
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const BUSINESS_ADDRESS_EDIT_CREATE_REQUEST = 'BUSINESS_ADDRESS_EDIT_CREATE_REQUEST'
export const BUSINESS_ADDRESS_EDIT_CREATE_SUCCESS = 'BUSINESS_ADDRESS_EDIT_CREATE_SUCCESS'
export const BUSINESS_ADDRESS_EDIT_CREATE_FAILURE = 'BUSINESS_ADDRESS_EDIT_CREATE_FAILURE'

export const createBusinessAddress = (id, body) => ({
  [CALL_API]: {
    endpoint: `/api/business/businesses/${id}/addresses/`,
    types: [
      BUSINESS_ADDRESS_EDIT_CREATE_REQUEST,
      BUSINESS_ADDRESS_EDIT_CREATE_SUCCESS,
      BUSINESS_ADDRESS_EDIT_CREATE_FAILURE,
    ],
    method: 'POST',
    body,
    tokenType: API_JWT_TOKEN_NAME,
  },
})
